import React, { useState } from 'react';
import styles from '../../CaseType/ListHeader/CaseTypeListHeader.module.scss';
import Text from '../../../../../Components/Base/Text/Text';
import Button from '../../../../../Components/Button/Button';
import { Theme } from '../../../../../Enums/Theme.enum';
import ManagerWorkplaceCreateOptionsListModal from '../ManagerWorkplaceCreate/ManagerWorkplaceCreateOptionsListModal';

interface Props {
	onCreate: () => void;
}

const ManagerWorkplaceToolbar: React.FC<Props> = ({ onCreate }) => {
	const [isCreateOpen, setIsCreateOpen] = useState(false);

	const handleOnSuccess = () => {
		setIsCreateOpen(false);
		onCreate();
	};

	return (
		<div className={styles.wrapper}>
			<Text tx='component.workplaceAndWorkers.text7' className={styles.title} />
			<div className={styles.controls}>
				<Button
					theme={Theme.GREEN}
					title='component.managerWorkplaceCreateButton.add'
					onClick={() => setIsCreateOpen(true)}
				/>
				{isCreateOpen && (
					<ManagerWorkplaceCreateOptionsListModal
						isOpen
						onClose={() => setIsCreateOpen(false)}
						onSuccess={handleOnSuccess}
					/>
				)}
			</div>
		</div>
	);
};

export default ManagerWorkplaceToolbar;
